import { http } from "../base";

export async function listEmployees(tenantId, keyword) {

  console.log("listEmployees",tenantId);
  const response = await http.post(
    `/tenant/listemployees`,
    { 'keyword': keyword, 'tenantId': tenantId, 'pageNo': 0, 'pageSize': 50 },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
    console.log("listEmployees response", response);
    // 统一处理响应格式
    if (response==null || response.status !== 200) {
      throw new Error(response.data.message || '获取员工列表失败');
    }
    return response.data;
  }

  export async function getEmployeeinfo(id) {

    console.log("getEmployeeinfo",id);
    const response = await http.get(
      `/employees/`+id,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
      console.log(response);
      // 统一处理响应格式
      if (response==null || response.status !== 200) {
        throw new Error(response.data.message || '获取员工信息失败');
      }
      return response.data;
    }

  export async function createEmployee(tenantId, employee) {

    console.log("createEmployee", tenantId, employee, employee.name);

    const response = await http.post(
      `/tenant/employee`,
      {
        userid: employee.userId,
        tenantid: tenantId,
        name: employee.name,
        phone: employee.phone,
        email: employee.email,
      },
      {
        headers: { 'Content-Type': 'application/json',
                    'X-Tenant-Id': tenantId  // 添加企业ID头
         }

      });
      console.log(response.data);
      // 统一处理响应格式
      if (response.data==null || response.data.code !== 200) {
        throw new Error(response.data.message || '保存失败');
      }
      return response.data;
    }

    // 更新员工信息的API
    export async function updateEmployee(tenantId, employee) {
        console.log("updateEmployee", tenantId, employee);
        const response = await http.put(
            `/tenant/employee/${employee.userId}`,
            {
                name: employee.name,
                email: employee.email,
                // 注意：不传 phone，因为手机号是用户名，不允许修改
            },
            {
                headers: { 
                    'Content-Type': 'application/json',
                    'X-Tenant-Id': tenantId
                }
            }
        );
        console.log(response.data);
        if (response.data == null || response.data.code !== 200) {
            throw new Error(response.data.message || '更新失败');
        }
        return response.data;
    }    

    export async function toggleUserStatus(tenantId, params) {
      console.log("disableUser - 前端调用参数:", { tenantId, params });
       try {
      const response = await http.post(
          `/employees/togglestatus/${params.userId}`,
          {}, // 第二个参数是请求体（可以为空对象）
          {   // 第三个参数是配置对象（包含headers）
              headers: {
                  'Content-Type': 'application/json',
                  'X-Tenant-Id': tenantId.toString() // 确保是字符串
              }
          }
      );

      console.log("toggleUserStatus - 响应:", response.data);
   /*   if (!response.data || response.data.code !== 200) {
          // 优先取业务消息，其次HTTP状态，最后兜底
      const errMsg = response.data?.message || `请求失败(HTTP ${response.status})`;
      throw new Error(errMsg);
      }*/
      return response;
       } catch (error) {
        // 打印完整错误，查看后端真实返回
        console.error("toggleUserStatus - 错误详情:", error.response?.data || error.message);
        
        // 透传后端message，避免被覆盖
        if (error.response?.data?.message) {
          throw new Error(error.response.data.message);
        }
        throw new Error(error.message || '切换用户状态失败');
      }
  }


  export async function deleteEmployee(tenantId, employeeId) {
    console.log("deleteEmployee - 前端调用参数:", { employeeId, tenantId });

    // 验证 tenantId 的值
    console.log("tenantId 值:", tenantId, "类型:", typeof tenantId);

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'X-Tenant-Id': tenantId.toString()
            }
        };

        console.log("请求配置:", config);

        const response = await http.delete(
            `/employees/${employeeId}`,
            config
        );

        console.log("deleteEmployee - 响应:", response.data);
        return response.data;
    } catch (error) {
        console.error("deleteEmployee - 错误:", error);
        throw error;
    }
}